import { ApiClient } from '@/lib/axios/client';
import type { CreateQrJobRequest, QrJob, QrJobItemListing, QrJobItemParams } from './types';

const basePath = (orgId: string) => `/api/v1/orgs/${orgId}/qr-jobs`;

export class QrJobApi {
  static async create(orgId: string, data: CreateQrJobRequest): Promise<QrJob> {
    return await ApiClient.post<QrJob>(basePath(orgId), data);
  }

  static async get(orgId: string, jobId: string): Promise<QrJob> {
    return await ApiClient.get<QrJob>(`${basePath(orgId)}/${jobId}`);
  }

  static async listItems(orgId: string, jobId: string, params?: QrJobItemParams): Promise<QrJobItemListing> {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.set('status', params.status);
    if (params?.page) queryParams.set('page', params.page.toString());
    if (params?.page_size) queryParams.set('page_size', params.page_size.toString());
    const query = queryParams.toString();
    return await ApiClient.get<QrJobItemListing>(`${basePath(orgId)}/${jobId}/items${query ? `?${query}` : ''}`);
  }

  /** Same-origin URL the browser can download directly (cookie auth), so the zip streams to disk. */
  static downloadUrl(orgId: string, jobId: string): string {
    return `${basePath(orgId)}/${jobId}/download`;
  }
}
